<div class="ai-comment-assistant-menu" cdkTrapFocus (keydown)="onMenuKeydown($event)">
  <div class="title-section">
    <h3 class="title">{{'ai-comment-assistant_title' | translate}}</h3>
    <button class="close-btn ficon-app-x icon-btn" (click)="onClose.emit()" [attr.aria-label]="'common_close' | translate">
    </button>
  </div>

  <div>
    @if (tagsList.length) {
      <div class="markers-original-comment">
        @for (tag of tagsList; track tag) {
          <marker
            [marker]="tag"
            [withName]="true">
          </marker>
        }
      </div>
    }
    <span class="original-comment text-overflow-multiline">{{plainCommentText}}</span>
  </div>

  <mat-divider></mat-divider>

  @if ((generating$ | async)) {
    <div class="loader" role="status" aria-live="polite">
      <span class="ficon-spinner ficon-spin" aria-hidden="true"></span>
      <span>{{'common_generating' | translate}}</span>
    </div>
  } @else {
    @if ((hasErrors$ | async)) {
      <div class="has-errors">
        @if (isRateLimited$ | async) {
          <div class="has-errors-text" role="alert">
            <span class="ficon-app-warning-circle-outline"></span>
            <span>{{'common_rate-limit-exceeded' | translate: { seconds: retryAfter$ | async } }}</span>
          </div>
        } @else {
          <div class="has-errors-text" role="alert">
            <span class="ficon-app-warning-circle-outline"></span>
            <span>{{'common_an-unexpected-error-occurred' | translate}}</span>
          </div>
        }
        <div class="has-errors-buttons-container">
          <button class="cancel-btn tertiary-btn" (click)="onClose.emit()">{{'common_cancel' | translate}}</button>
          <button class="try-again-btn primary-btn" (click)="fetchImprovedComment()" [disabled]="isRateLimited$ | async">{{'common_try-again' | translate}}</button>
        </div>
      </div>
    } @else {
      <div class="no-errors">
        <div class="improved-comment-title">
          <i class="ficon-sparkles-solid"></i>
          <span>{{'ai-comment-assistant_improved-comment' | translate}}</span>
        </div>
        @if (tagsList.length) {
          <div class="markers-improved-comment">
            @for (tag of tagsList; track tag) {
              <marker
                [marker]="tag"
                [withName]="true">
              </marker>
            }
          </div>
        }
        <p class="improved-comment">{{improvedComment}}</p>
        <div class="no-errors-buttons-container">
          <button class="cancel-btn tertiary-btn" (click)="onClose.emit()">{{'common_cancel' | translate}}</button>
          <button class="apply-btn primary-btn" (click)="apply()">{{'common_apply' | translate}}</button>
        </div>
      </div>
    }
  }

</div>
